import React, { Component } from 'react';

import AlgoliaContainer from 'containers/AlgoliaContainer';
import PropTypes from 'prop-types';
import { injectModels } from 'state';
import { transformAlgoliaProductResponse } from 'utils/dataTransformers/product';
import { withRouter } from 'react-router-dom';

class SearchContainer extends Component {
    static propTypes = {
        application: PropTypes.object.isRequired,
        categories: PropTypes.array,
        history: PropTypes.object.isRequired,
        ids: PropTypes.array,
        index: PropTypes.string,
        list: PropTypes.string,
        location: PropTypes.object.isRequired,
        pageSize: PropTypes.number,
        render: PropTypes.func.isRequired,
        renderProps: PropTypes.object,
        responseCallback: PropTypes.func,
        search: PropTypes.string,
        tags: PropTypes.array,
    };

    static defaultProps = {
        categories: [],
        ids: [],
        index: 'products',
        list: '',
        pageSize: 5,
        renderProps: {},
        responseCallback: null,
        search: '',
        tags: [],
    };

    constructor(props) {
        super(props);

        this.state = {
            index: props.index,
        };
    }

    shouldComponentUpdate(nextProps) {
        const { application, ...props } = this.props;
        const { application: nextApplication, ...newNextProps } = nextProps;

        if (JSON.stringify(props) !== JSON.stringify(newNextProps)) {
            return true;
        }

        if (
            JSON.stringify(application.shop_config) !== JSON.stringify(nextApplication.shop_config) ||
            application.locale !== nextApplication.locale
        ) {
            return true;
        }

        return false;
    }

    parameters = (ids, categories, tags, pagination, pageSize, application) => ({
        page: pagination,
        hitsPerPage: pageSize,
        filters: [
            [`_pricelists:${application.shop_config.pricelist_id}`],
            [`_marketplaces:${application.shop_config.market_id}`],

            // Only for the backup products, these are not gonna be needed for the normal query.
            ids.map(id => `objectID:"${id}"`),
            categories.map(c => `_categories_ids:"${c}"`),
            tags.map(c => `_keywords:"${c}"`),

            // ONLY SHOW PRODUCTS IN STOCK BASED ON MARKET_ID
            //[`_in_stock:${application.shop_config.market_id}`],
        ].filter(i => i.length !== 0),
    });

    getParameters = () => {
        const { ids, categories, tags, pageSize, search, application } = this.props;
        const { index } = this.state;
        const parameters = [];
        const locale = application.locale;
        const indexName = `${index}_${locale}`;

        // todo: only get default once per changed filter default
        // default products
        parameters.push({
            indexName,
            params: this.parameters(ids, categories, tags, 1, pageSize, application),
        });

        // search query
        parameters.push({
            indexName,
            query: search,
            params: this.parameters([], [], [], 1, pageSize, application),
        });

        // Categories
        parameters.push({
            indexName: 'product_categories',
            query: search,
            params: {
                page: 1,
                hitsPerPage: 4,
                filters: [[`application_id:${application.applicationId}`]],
            },
        });

        return parameters;
    };

    responseCallback = response => {
        if (!response) {
            return null;
        }

        const { responseCallback, application, list } = this.props;
        const fallbackProducts = transformAlgoliaProductResponse(response[0], application);
        const products = transformAlgoliaProductResponse(response[1] || {}, application);

        const data = {
            products: products.hits,
            fallbackProducts: fallbackProducts.hits,
            hitsCount: products.nbHits,
            categories: response[2].hasOwnProperty('hits') && response[2].hits,
            list,
        };

        return responseCallback ? responseCallback(data) : data;
    };

    render() {
        const { render, renderProps } = this.props;
        return (
            <AlgoliaContainer
                renderProps={renderProps}
                parameters={this.getParameters()}
                responseCallback={this.responseCallback}
                render={({ application, ...rest }) => render({ ...rest })}
            />
        );
    }
}

export default withRouter(injectModels(['application'])(SearchContainer));
